module.exports = __webpack_public_path__ + "static/media/skating.74af2a65.svg";